import React from "react";
import { useNavigate } from "react-router-dom";
import { DocumentTemplateFormValues, DocumentTemplateForm } from "./DocumentTemplateForm";
import { documentTemplatesApi } from "api";
import { routes } from "consts";
import { useToaster } from "utils";
import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";

export const AddDocumentPage = (): JSX.Element => {
  const navigate = useNavigate();
  const { showSuccess } = useToaster();

  const onSubmit = async (data: DocumentTemplateFormValues) => {
    const { data: templateId } = await documentTemplatesApi.create(data);
    navigate(routes.DOCUMENTS_PAGES(templateId + ""));
    showSuccess(`Utworzono dokument`);
  };

  const breadcrumbs = [
    { title: "Szablony dokumentów", path: routes.DOCUMENTS },
    { title: "Tworzenie nowego szablonu" },
  ];

  return (
    <PageMain>
      <HeaderWithBreadcrumbs breadcrumbs={breadcrumbs} headerText="Dodaj szablon" />
      <DocumentTemplateForm onSubmit={onSubmit} />
    </PageMain>
  );
};
